<template>

    <div>

        <div class="tabs">
            <ul>
                <li :class="{'is-active': (sort==='name')}" @click="sort='name'"><a>By Name</a></li>
                <li :class="{'is-active': (sort==='popular')}" @click="sort='popular'"><a>By Popularity</a></li>
                <li :class="{'is-active': (sort==='find')}" @click="sort='find'"><a>Find a Tag</a></li>
            </ul>
        </div>

        <div v-if="sort==='find'">
            <div class="searchInput">
                <input
                    id="searchInput-input"
                    class="searchInput__input"
                    type="text"
                    placeholder="search"
                    v-model.trim="search"
                />
                <div class="searchInput__searchicon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                </div>
            </div>
        </div>

        <div class="field is-grouped is-grouped-multiline">
            <div v-for="tag in filteredTags" :key="tag.name" class="control">
                <div  class="tags has-addons">
                    <a :href="'/tag/' + tag.name" class="tag is-link is-medium">{{ tag.name }}</a>
                    <span class="tag is-medium is-dark">{{ tag.count }}</span>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

import _ from 'lodash';

export default {

    data() {
        return {
            tags: window.existingTags,
            sort: 'name',
            search: ''
        };
    },

    mounted() {
        this.tags = window.AR.data.tags ? window.AR.data.tags : [];
    },

    computed: {
        filteredTags() {
            if (this.sort === 'name') {
                return _.sortBy(this.tags, tag => tag.name);
            } else if (this.sort === 'popular') {
                return _.sortBy(this.tags, tag => (0-tag.count));
            } else {
                return this.tags.filter((tag) => {
                    return tag.name
                        .toString()
                        .toLowerCase()
                        .indexOf(this.search.toLowerCase()) >= 0
                });
            }
        }
    }

}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/TagsList.vue